<template>
  <div class='view-contents'>
    <div class="row title-row">
      <div class="col section-title">
        Admin Page
      </div>
    </div>
    <div class="section-header">
    </div>
    <div class="mid-page-section-header normal-title">
      Admin Menu
    </div>
    <div id="admin-menu" class="card card-body">
      <router-link
              :to="{ name: 'TOGmanagement' }"
              active-class="router-link-active">
              <span class="side-panel-label">Targets, Objectives, and Goals Management</span>
            </router-link>

    </div>
  </div>
</template>
<style>

  #admin-menu {
    max-width:450px;
    background-color:#F6F6F6;
  }
</style>
<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Admin',
  mounted() {

  },
  computed: {
    ...mapState('AdminMenu', {
    }),
    ...mapGetters('AdminMenu', [
    ]),
  },
  methods: {
    selectAllIds() {
      this.selectedBillIds = this.approvedWorkOrderBills.map((bill) => bill.id);
    },
    unselectAllIds() {
      this.selectedBillIds = [];
    },
    markAsPaid() {
      this.$store.dispatch('WorkorderBill/markBillsAsPaid', this.selectedBillIds);
      if (!this.serverError || this.serverError === '') {
        window.location.href = `mailto:${this.selectedBillsEmails()}?subject=Bill(s) Paid&body=${this.emailBody()}`;
      }
    },
    exportBills() {
      return this.$store.dispatch('WorkorderBill/downloadBills', this.selectedBillIds);
    },
    selectedBillsEmails() {
      return this.selectedBills().map((bill) => bill.projectManagerEmail).join(';');
    },
    emailBody() {
      return encodeURIComponent(this.selectedBills()
        .map((bill) => `${bill.projectName}: ${this.workorderHref(bill)}`)
        .join('\n'));
    },
    workorderHref(bill) {
      return `${window.location.href.slice(0, window.location.href.lastIndexOf('/'))}/project/${bill.projectId}/workorders/${bill.workOrderId}/bill/${bill.id}`;
    },
    selectedBills() {
      if (this.selectedBillIds) {
        return this.approvedWorkOrderBills
          .filter((bill) => this.selectedBillIds.includes(bill.id));
      }
      return [];
    },
  },
};
</script>
